import React, {useState} from 'react';
import {DatePicker, Flex} from "antd";
import {t} from "i18next";
import {ReportsFilter} from "./index";
import ButtonBlack from "../../components/ui/buttons/ButtonBlack";
import useFiltersData from "./useFiltersData";
import Settings from "./Settings";
import dayjs from "dayjs";
import FilterSelect from "./FilterSelect";
import {AllProductsReport} from "./AllProducts";

const {RangePicker} = DatePicker;

interface FilterProps {
  reportsFilter: ReportsFilter,
  setReportsFilter: Function,
  selectedItem: AllProductsReport | undefined,
}

export default function Filter({reportsFilter, setReportsFilter, selectedItem}: FilterProps) {
  const [filter, setFilter] = useState<ReportsFilter>(reportsFilter);

  const {
    poolsOptions,
    companiesOptions,
    productsOptions,
    kpisOptions,
    setPoolSearch,
    setCompanySearch,
    setProductSearch,
  } = useFiltersData(filter);

  const submit = () => {
    setReportsFilter(filter)
  };

  return (
    <>
      {!selectedItem &&
        <Flex className={'reports-filter'}>
          <Flex style={{width: '100%'}} align={'center'}>
            <Flex gap={'small'} align={'flex-end'}>
              <Flex vertical gap={6}>
                <Flex className={'reports-filter__title'}>
                  {t('brief.pool')}
                </Flex>
                <FilterSelect
                  name={'pools'}
                  options={poolsOptions}
                  setSearch={setPoolSearch}
                  setFilter={setFilter}
                  filter={filter}
                  placeholder={t('brief.pool')}
                  onValueChange={() => {
                    delete filter.companies;
                    delete filter.products;
                    setCompanySearch('')
                  }}
                  disabled={false}
                  showSearch={true}
                />
              </Flex>
              <Flex vertical gap={6}>
                <Flex className={'reports-filter__title'}>
                  {t('brief.company')}
                </Flex>
                <FilterSelect
                  name={'companies'}
                  options={companiesOptions}
                  setSearch={setCompanySearch}
                  setFilter={setFilter}
                  filter={filter}
                  placeholder={t('brief.company')}
                  onValueChange={() => {
                    delete filter.products;
                    setProductSearch('')
                  }}
                  disabled={false}
                  showSearch={true}
                  status={(!filter.companies || filter.companies.length === 0) ? 'error' : ''}
                />
              </Flex>
              <Flex vertical gap={6}>
                <Flex className={'reports-filter__title'}>
                  {t('brief.product')}
                </Flex>
                <FilterSelect
                  name={'products'}
                  options={productsOptions}
                  setSearch={setProductSearch}
                  setFilter={setFilter}
                  filter={filter}
                  placeholder={t('brief.product')}
                  onValueChange={() => {}}
                  disabled={false}
                  showSearch={true}
                />
              </Flex>
              <Flex vertical gap={6}>
                <Flex className={'reports-filter__title'}>
                  {t('brief.kpi')}
                </Flex>
                <FilterSelect
                  name={'kpis'}
                  options={kpisOptions}
                  setSearch={() => {}}
                  setFilter={setFilter}
                  filter={filter}
                  placeholder={t('brief.kpi')}
                  onValueChange={() => {}}
                  disabled={false}
                  showSearch={false}
                />
              </Flex>
              <Flex vertical gap={6}>
                <Flex className={'reports-filter__title'}>
                  {t('reports.period')}
                </Flex>
                <RangePicker
                  size={'large'}
                  placeholder={[t('list.dateStart'), t('list.dateEnd')]}
                  onChange={(date) => {
                    if (date) {
                      setFilter({
                        ...filter,
                        period: date,
                      })
                    } else {
                      setFilter({
                        ...filter,
                        period: null,
                      })
                    }
                  }}
                  format={'DD.MM.YYYY'}
                  value={(filter.period && filter.period[0] && filter.period[1]) ? [
                    dayjs(filter.period[0], 'DD.MM.YYYY'),
                    dayjs(filter.period[1], 'DD.MM.YYYY'),
                  ] : undefined}
                  disabled={false}
                />
              </Flex>
              <ButtonBlack
                className={'reports-filter__button'}
                onClick={submit}
                size={'large'}
                disabled={!filter.companies || filter.companies.length === 0}
              >{t('reports.applyFilter')}</ButtonBlack>
            </Flex>
          </Flex>
        </Flex>
      }

      {!selectedItem &&
        <Settings
          selectedChannelsIds={filter.channels || []}
          setSelectedChannelsIds={(data: string[]) => setFilter({
            ...filter,
            channels: data,
          })}
          companies={filter?.companies || []}
        />
      }
    </>
  );
}
